module.exports = __webpack_public_path__ + "img/banner0.eec7bf00.png";